import React from 'react';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import { IconsBoxData } from '@data/proviotics';

interface Props {
  data: IconsBoxData;
  title?: string;
  index: number;
}

const IconsBox: React.FC<Props> = ({ data, index }) => (
  <Container key={index}>
    <TitleWrap>{data.title.toUpperCase()}</TitleWrap>
    <IconContainer>
      {data.iconsWithText.map((item, index) => (
        <IconWrap key={index}>
          <IconImage src={item.icon} />
          <TextWrap>{item.text}</TextWrap>
        </IconWrap>
      ))}
    </IconContainer>
  </Container>
);

export default IconsBox;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 535px;
  border: 2px solid #dce9f2;
  margin-bottom: 120px;
  margin-top: 40px;
  background: #fffbe7;
  padding: 30px 40px;

  @media (max-width: 1024px) {
    margin-bottom: 20px;
    margin-left: 20px;
    padding: 30px 30px;
    max-width: 280px;
  }
`;

const IconContainer = styled.div`
  display: flex;
  justify-content: space-evenly;

  @media (max-width: 1024px) {
    flex-wrap: wrap;
    width: 210px;
  }
`;

const TitleWrap = styled.div`
  color: ${Colors.navyBlue};
  font-family: BrownStd;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 14px;
  letter-spacing: 1px;
  text-align: left;
`;

const IconWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 95px;
  margin: 35px 18px 0 18px;

  @media (max-width: 1024px) {
    margin: 35px 0 0 0;
  }
`;

const IconImage = styled.img`
  height: 60px;
`;

const TextWrap = styled.div`
  color: ${Colors.navyBlue};
  text-align: center;
  margin-top: 20px;
  width: 100%;

  font-family: BrownStd;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0;
  text-align: center;
`;
